import { useMemo } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { sailorRiskProfileSchema } from "../util/schema";

export const useSailorRiskProfile = ({ sailorId }) => {
  const [value, loading, error] = useDocument(
    doc(db, "sailorRiskProfiles", sailorId),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  const sailorRiskProfile = useMemo(() => {
    return value ? mapSailorRiskProfile(value) : undefined;
  }, [value]);
  return { sailorRiskProfile, loading, error };
};

const mapSailorRiskProfile = (docRef) => {
  if (!docRef.exists()) {
    return {};
  }

  let sailorRiskProfile = sailorRiskProfileSchema.cast(docRef.data());
  sailorRiskProfile.id = docRef.id;

  return sailorRiskProfile;
};
